import * as React from 'react';

export default function useToggle(
  defaultValue: boolean = false,
): [boolean, (value?: boolean) => void] {
  const [open, setOpen] = React.useState(defaultValue);

  const toggle = React.useCallback(
    (value?: boolean) => {
      if (value === undefined) {
        setOpen(!open);
      } else {
        setOpen(value);
      }
    },
    [open],
  );
  return [open, toggle];
}
